import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
// import {DateRangePickerPopoverComponent} from "../date-range-picker-popover/date-range-picker-popover.component";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import {DateRangePickerPopoverComponent} from "../date-range-picker-popover/date-range-picker-popover.component";
@Component({
  selector: 'app-date-range-filter',
  templateUrl: './date-range-filter.component.pug',
  styleUrls: ['./date-range-filter.component.scss'],
  standalone: false
})
export class DateRangeFilterComponent implements OnInit {

  @Input() start!: any;
  @Input() end!: any;
  @Input() filterBy = '';
  @Input() filter = $localize`Custom`;
  @Output() filterUpdate = new EventEmitter();
  @ViewChild('dateFilter', {static: false}) dateFilter: any;
  @ViewChild(DateRangePickerPopoverComponent, { read: ElementRef, static: false }) popoverRef: any;
  @Input() filterByOptions: any;
  @Input() isDisabled: boolean = false;

  startStr = '';
  endStr = '';

  bsModalRef!: BsModalRef;

  constructor(
      private eRef: ElementRef,
      private modalService: BsModalService,
      private permissionsService: PermissionsService
  ) {
  }

  ngOnInit(): void {
    this.setLabel();
  }

  private setLabel() {
    this.startStr = this.start.format('L');
    this.endStr = this.end.format('L');
  }

  update(event) {
    this.start = event['start'];
    this.end = event['end'];
    this.filterBy = event['filterBy'];
    this.filter = event['filter'];
    this.setLabel();

    localStorage.setItem('insights-filter', JSON.stringify({'start_date': this.start, 'end_date': this.end, 'filterBy': this.filterBy, 'filter': this.filter}));
    this.filterUpdate.emit({'start': this.start, 'end': this.end, 'filterBy': this.filterBy, 'filter': this.filter});

  }
  @HostListener('document:click', ['$event'])
  clickout(event) {
    let insideClick = this.eRef.nativeElement.contains(event.target) ||
      (this.popoverRef?.nativeElement?.contains(event.target)) ||
      (event?.target?.id === 'DateRangeDropdown') ||
      (event?.target?.classList?.contains('is-highlighted'));
    if (!insideClick) {
      this.dateFilter.hide();
    }
  }
}
